import {Device} from "src/app/infrastructure/moovement-api/models/asset";

export function isWaterMonitor(device: Device) {
  return device.capabilities.includes('WaterLevel');
}
